import { TrackingTypeState } from 'components/search/expedia/interfaces';
import { TrackingType } from 'components/search/expedia/enums';

const initialTrackingTypeState: TrackingTypeState = {
  // trackingType: TrackingType.NONE,
  trackingType: TrackingType.PZ,
};

export { initialTrackingTypeState };
